import React, { useState, useEffect } from "react";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";

function About() {
  const images = [
    "/images/image1.jpg", // Replace with actual image paths
    "/images/pop.png",
    "/images/image3.jpg",
    "/images/image4.jpg",
    "/images/image5.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };
  return (
    <div className="about-page">
      {/* Header Section */}
      <header className="about-header">
        <div className="section-content">
          <h1>About District Chaman</h1>
          <p>
            Discover the rich history, culture, and development initiatives of
            Chaman, a significant district in Balochistan, Pakistan.
          </p>
        </div>
      </header>

      {/* Mission Section */}
      <section className="mission-vision">
        <div className="container">
          <div className="section-contentm">
            <h2>Our Mission</h2>
            <p id="mv">
              To foster growth and development in Chaman while preserving its
              cultural heritage and addressing the needs of its people.
            </p>
          </div>

          {/* Vision Section */}
          <div className="section-contentm">
            <h2>Our Vision</h2>
            <p id="mv">
              Envisioning a prosperous Chaman with empowered citizens and a
              thriving economy.
            </p>
          </div>
        </div>
      </section>

     {/* Beauty Section */}
     {/* <section className="beauty-section">
  <h2>Explore District Chaman's Beauty</h2>
  <div className="image-carousel">
    <button className="beauty-carousel-btn beauty-prev-btn" onClick={handlePrev}>
      &#10094;
    </button>
    <div className="image-container">
      <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
        className="carousel-imagea"
      />
    </div>
    <button className="beauty-carousel-btn beauty-next-btn" onClick={handleNext}>
      &#10095;
    </button>
  </div>
</section> */}

    </div>


  );
}

export default About;
